import { render, staticRenderFns } from "./CrmRedirect.vue?vue&type=template&id=df882808&"
import script from "./CrmRedirect.vue?vue&type=script&lang=js&"
export * from "./CrmRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports